<template>
	<button :class="btnType" type="button"><slot></slot></button>
</template>

<script>
export default {
	props: {
		btnType: String,
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/main.scss";

button {
	display: inline-block;

	padding: 1em 1.5em;
	border: none;
	border-radius: $border-m;

	font-size: 14px;
	color: #ffffff;

	transition-duration: $trd-m;
	cursor: pointer;

	&.small {
		padding: 0.5em 1.5em;
		font-size: 13px;
	}

	&.full-width {
		width: 100%;
	}

	&:active,
	&:focus {
		outline: none;
		border: none;
	}
}
</style>
